import { Reloader } from './Reloader';

const REDEEM_FAILED_ERROR = 'redeem.bonuspoints.failed';

export class BonusPoints {
    static REDEMPTION_ERROR_MESSAGE_ID = 'checkout.bonusPoints.redemptionError';

    constructor(private readonly reloader: Reloader) {}

    async _handleRedeemBonusPointsResponse(response: Response) {
        if (response.status === 200 || response.status === 422 || response.status === 404) {
            try {
                await this.reloader.trigger();
            } catch (e) {
                console.error(e);
                throw e;
            }

            return response;
        }
        return Promise.reject(REDEEM_FAILED_ERROR);
    }

    async redeemBonusPointsAndReload(toBeRedeemed: string) {
        const response = await fetch('/order/bonusPoints', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ redeemed: toBeRedeemed })
        });
        return this._handleRedeemBonusPointsResponse(response);
    }

    renderBonusPointRedemptionError() {
        const redemptionError = document.getElementById('or_js_bonusPoints__redemptionError');
        if (!!redemptionError) {
            redemptionError.style.display = 'block';
            redemptionError.textContent = 'Das hat leider nicht geklappt. Bitte versuche es erneut.';
        }
    }
}
